import React from 'react'
import RealGDPPerCapitaChart from './RealGDPPerCapitaChart'

export default function RealGDPPerCapita() {
  return (
    <>
      <RealGDPPerCapitaChart />
    </>
  )
}
